import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  styled,
  Typography,
} from '@mui/material'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { Project } from '../../models/Organization'
import { calculateAge } from '../../utils/Common'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useLocation, useNavigate } from 'react-router-dom'
import { deleteProjectAsync } from '../../services/projectsService'
import { useState } from 'react'
import { CustomMenuList } from '../CustomMenuListComponent'

interface ProjectCardProps {
  project: Project
}

const filesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.files,
)

const ProjectCardComponent: React.FC<ProjectCardProps> = ({ project }) => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const location = useLocation()
  const [contextMenu, setContextMenu] = useState<
    { mouseX: number; mouseY: number } | undefined
  >()
  const files = useSelector(filesSelector)

  const handleProjectClick = () => {
    if (!Boolean(contextMenu)) {
      navigate(`${location.pathname}/${project.id}/files`)
    }
  }

  const handleProjectContextMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
    setContextMenu(
      !Boolean(contextMenu)
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : undefined,
    )
    const selection = document.getSelection()
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0)

      setTimeout(() => {
        selection.addRange(range)
      })
    }
  }

  const handleClose = () => {
    setContextMenu(undefined)
  }

  const handleDeleteProjectClick = () => {
    dispatch(deleteProjectAsync({ projectId: project.id }))
    handleClose()
  }

  return (
    <Button
      onClick={handleProjectClick}
      onContextMenu={handleProjectContextMenu}
      disableRipple
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        p: '1rem',
        background: '#F5F5F1',
        boxShadow: '0px 2px 10px 0px #0000001A',
        borderRadius: '0.4rem',
        textTransform: 'none',
        textAlign: 'left',
      }}
    >
      <Box width='100%' display='flex' flexDirection='column' gap='1rem'>
        <Box display='flex' flexDirection='column'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.94rem',

              color: '#04002E',
            }}
          >
            {project.name}
          </Typography>
          <Typography
            component='div'
            sx={{
              fontSize: '0.82rem',

              color: '#878787',
            }}
          >
            Apex Builders Group
          </Typography>
        </Box>
        <Box
          component='img'
          src='/images/projectImage.png'
          alt='Project Thumbnail'
          sx={{
            width: '100%',
            borderRadius: '0.2rem',
          }}
        ></Box>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',

              color: '#04002E',
            }}
          >
            {files.filter((file) => file.project_id === project.id).length}{' '}
            Files
          </Typography>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.58rem',

              color: '#04002E',
            }}
          >
            Updated: {calculateAge(project.updatedAt ?? Date.now().toString())}
          </Typography>
        </Box>
      </Box>
      <Menu
        open={Boolean(contextMenu)}
        onClose={handleClose}
        anchorReference='anchorPosition'
        anchorPosition={
          contextMenu
            ? { left: contextMenu.mouseX, top: contextMenu.mouseY }
            : undefined
        }
        MenuListProps={{
          disablePadding: true,
          component: CustomMenuList,
        }}
        slotProps={{
          paper: {
            sx: {
              border: 'none',
              padding: 0,
              width: '7rem',
            },
          },
        }}
      >
        <MenuItem onClick={() => {}}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.64rem',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Move
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleDeleteProjectClick}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.64rem',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Delete
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Button>
  )
}

export default ProjectCardComponent
